//@ts-nocheck
import React, { useContext, Fragment } from "react";
import Menu, { MenuProps } from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
import CancelIcon from "@material-ui/icons/Cancel";
import Popover, { PopoverProps } from "@material-ui/core/Popover";

import {
  Theme,
  createStyles,
  makeStyles,
  useTheme,
  withStyles,
} from "@material-ui/core/styles";
import { DigimonData, CardInfo, NetPanelMode } from "../cardinfo";
import cardsStore from "../store/cards/cards";
//import { EditMode } from "./deckBuilderDrawer";

//const file_name = "file-name"
//<img src=`${images[file_name]}` />

export const initialMenuState = {
  mouseX: null,
  mouseY: null,
  card: null,
};

const StyledMenu = withStyles({
  paper: {
    border: "0.1vmin black solid",
    "border-radius": "2vmin",
    "background-color": "#DFDBE5",
    "background-image": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 304 304' width='304' height='304'%3E%3Cpath fill='%239C92AC' fill-opacity='0.25' d='M44.1 224a5 5 0 1 1 0 2H0v-2h44.1zm160 48a5 5 0 1 1 0 2H82v-2h122.1zm57.8-46a5 5 0 1 1 0-2H304v2h-42.1zm0 16a5 5 0 1 1 0-2H304v2h-42.1zm6.2-114a5 5 0 1 1 0 2h-86.2a5 5 0 1 1 0-2h86.2zm-256-48a5 5 0 1 1 0 2H0v-2h12.1zm185.8 34a5 5 0 1 1 0-2h86.2a5 5 0 1 1 0 2h-86.2zM258 12.1a5 5 0 1 1-2 0V0h2v12.1zm-64 208a5 5 0 1 1-2 0v-54.2a5 5 0 1 1 2 0v54.2zm48-198.2V80h62v2h-64V21.9a5 5 0 1 1 2 0zm16 16V64h46v2h-48V37.9a5 5 0 1 1 2 0zm-128 96V208h16v12.1a5 5 0 1 1-2 0V210h-16v-76.1a5 5 0 1 1 2 0zm-5.9-21.9a5 5 0 1 1 0 2H114v48H85.9a5 5 0 1 1 0-2H112v-48h12.1zm-6.2 130a5 5 0 1 1 0-2H176v-74.1a5 5 0 1 1 2 0V242h-60.1zm-16-64a5 5 0 1 1 0-2H114v48h10.1a5 5 0 1 1 0 2H112v-48h-10.1zM66 284.1a5 5 0 1 1-2 0V274H50v30h-2v-32h18v12.1zM236.1 176a5 5 0 1 1 0 2H226v94h48v32h-2v-30h-48v-98h12.1zm25.8-30a5 5 0 1 1 0-2H274v44.1a5 5 0 1 1-2 0V146h-10.1zm-64 96a5 5 0 1 1 0-2H208v-80h16v-14h-42.1a5 5 0 1 1 0-2H226v18h-16v80h-12.1zm86.2-210a5 5 0 1 1 0 2H272V0h2v32h10.1zM98 101.9V146H53.9a5 5 0 1 1 0-2H96v-42.1a5 5 0 1 1 2 0zM53.9 34a5 5 0 1 1 0-2H80V0h2v34H53.9zm60.1 3.9V66H82v64H69.9a5 5 0 1 1 0-2H80V64h32V37.9a5 5 0 1 1 2 0zM101.9 82a5 5 0 1 1 0-2H128V37.9a5 5 0 1 1 2 0V82h-28.1zm16-64a5 5 0 1 1 0-2H146v44.1a5 5 0 1 1-2 0V18h-26.1zm102.2 270a5 5 0 1 1 0 2H98v14h-2v-16h124.1zM242 149.9V160h16v34h-16v62h48v48h-2v-46h-48v-66h16v-30h-16v-12.1a5 5 0 1 1 2 0zM53.9 18a5 5 0 1 1 0-2H64V2H48V0h18v18H53.9zm112 32a5 5 0 1 1 0-2H192V0h50v2h-48v48h-28.1zm-48-48a5 5 0 0 1-9.8-2h2.07a3 3 0 1 0 5.66 0H178v34h-18V21.9a5 5 0 1 1 2 0V32h14V2h-58.1zm0 96a5 5 0 1 1 0-2H137l32-32h39V21.9a5 5 0 1 1 2 0V66h-40.17l-32 32H117.9zm28.1 90.1a5 5 0 1 1-2 0v-76.51L175.59 80H224V21.9a5 5 0 1 1 2 0V82h-49.59L146 112.41v75.69zm16 32a5 5 0 1 1-2 0v-99.51L184.59 96H300.1a5 5 0 0 1 3.9-3.9v2.07a3 3 0 0 0 0 5.66v2.07a5 5 0 0 1-3.9-3.9H185.41L162 121.41v98.69zm-144-64a5 5 0 1 1-2 0v-3.51l48-48V48h32V0h2v50H66v55.41l-48 48v2.69zM50 53.9v43.51l-48 48V208h26.1a5 5 0 1 1 0 2H0v-65.41l48-48V53.9a5 5 0 1 1 2 0zm-16 16V89.41l-34 34v-2.82l32-32V69.9a5 5 0 1 1 2 0zM12.1 32a5 5 0 1 1 0 2H9.41L0 43.41V40.6L8.59 32h3.51zm265.8 18a5 5 0 1 1 0-2h18.69l7.41-7.41v2.82L297.41 50H277.9zm-16 160a5 5 0 1 1 0-2H288v-71.41l16-16v2.82l-14 14V210h-28.1zm-208 32a5 5 0 1 1 0-2H64v-22.59L40.59 194H21.9a5 5 0 1 1 0-2H41.41L66 216.59V242H53.9zm150.2 14a5 5 0 1 1 0 2H96v-56.6L56.6 162H37.9a5 5 0 1 1 0-2h19.5L98 200.6V256h106.1zm-150.2 2a5 5 0 1 1 0-2H80v-46.59L48.59 178H21.9a5 5 0 1 1 0-2H49.41L82 208.59V258H53.9zM34 39.8v1.61L9.41 66H0v-2h8.59L32 40.59V0h2v39.8zM2 300.1a5 5 0 0 1 3.9 3.9H3.83A3 3 0 0 0 0 302.17V256h18v48h-2v-46H2v42.1zM34 241v63h-2v-62H0v-2h34v1zM17 18H0v-2h16V0h2v18h-1zm273-2h14v2h-16V0h2v16zm-32 273v15h-2v-14h-14v14h-2v-16h18v1zM0 92.1A5.02 5.02 0 0 1 6 97a5 5 0 0 1-6 4.9v-2.07a3 3 0 1 0 0-5.66V92.1zM80 272h2v32h-2v-32zm37.9 32h-2.07a3 3 0 0 0-5.66 0h-2.07a5 5 0 0 1 9.8 0zM5.9 0A5.02 5.02 0 0 1 0 5.9V3.83A3 3 0 0 0 3.83 0H5.9zm294.2 0h2.07A3 3 0 0 0 304 3.83V5.9a5 5 0 0 1-3.9-5.9zm3.9 300.1v2.07a3 3 0 0 0-1.83 1.83h-2.07a5 5 0 0 1 3.9-3.9zM97 100a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-48 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 96a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-144a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm96 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM49 36a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-32 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM33 68a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 240a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm80-176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 48a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm112 176a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-16 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 180a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 16a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0-32a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6zM17 84a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm32 64a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm16-16a3 3 0 1 0 0-6 3 3 0 0 0 0 6z'%3E%3C/path%3E%3C/svg%3E"), linear-gradient(to right, #2980b9, #6dd5fa, #ffffff)`,
    color: "black",
  },
})((props: PopoverProps) => (
  <Popover
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

interface styleProp {
  show: number;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      //'pointer-events': 'none',
      "user-select": "none",
      opacity: (props: styleProp) => props.show,
      "font-size": "2vmin",
      "flex-direction": "column",
      color: "white",
      margin: "0.5vmin",
    },
    subroot: {
      display: "flex",
      "flex-direction": "row",
      "flex-wrap": "wrap",
    },
    close: {
      position: "absolute",
      right: "0.5vmin",
      "& svg:hover": {
        transform: "rotate(360deg)",
        transition: "1s",
      },
    },
    image: {
      flex: "1",
      height: "60vmin",
      "object-fit": "cover",
      "z-index": "-2",
      border: "2px solid black",
      "border-radius": "2vmin",
      margin: "0.5vmin 1vmin 0  1vmin",
    },
    name: {
      width: "30vmin",
      "font-size": "3vmin",
      "font-weight": 900,
      color: "black",
      userSelect: "auto",
    },
    subCol: {
      flex: "1",
      display: "flex",
      "flex-direction": "column",
      "flex-wrap": "wrap",
      "padding-left": "0.5vmin",
      "padding-right": "0.5vmin",
      userSelect: "auto",
    },
    property: {
      background: "#5559",
      "border-radius": "0.75vmin",
      display: "flex",
      "justify-content": "space-between",
      "margin-bottom": "1px",
      userSelect: "auto",
    },
    label: {
      "padding-left": "0.5vmin",
    },
    value: {
      "padding-right": "0.5vmin",
      "text-align": "end",
      "max-width": "40vmin",
      userSelect: "all",
    },
    valueLong: {
      "padding-right": "0.5vmin",
      "text-align": "start",
      "max-width": "55vmin",
      userSelect: "all",
    },
  })
);

export const ContextMenuClick = (
  cards,
  setMenuState,
  setWorkingDeck,
  card: DigimonData,
  rightClick: boolean = true,
  otherData: any = {}
) => {
  const { panelMode, workingDeck } = cards;
  //const { netPanelMode, setAppState, workingDeck } = netPanel as NetPanelProps;
  const showPanel = (event: React.MouseEvent<HTMLDivElement>) => {
    event.preventDefault();
    setMenuState({
      mouseX: event.clientX - 5,
      mouseY: event.clientY - 5,
      card: card,
    });
  };
  switch (panelMode) {
    case NetPanelMode.normal:
      return showPanel;
    case NetPanelMode.builder:
      if (rightClick) {
        return showPanel;
      } else {
        //add to working deck

        //remove
        // if (
        //   otherData &&
        //   otherData.source == "smallcard" &&
        //   otherData.editMode != EditMode.MoveCards
        // ) {
        //   return () => {};
        //   /*
        //             return()=>{
        //                 const index = (workingDeck as number[]).lastIndexOf(card.baseid);
        //                 const newWorkingDeck = [...workingDeck];
        //                 newWorkingDeck.splice(index,1);
        //                 setAppState({workingDeck: newWorkingDeck });
        //             }*/
        // }

        //add if count < 4
        return () => {
          if (
            (workingDeck as number[]).reduce((a, cur, curi, arr) => {
              if (cur == card.baseid) {
                return a + 1;
              }
              return a;
            }, 0) < 4
          ) {
            var newWorkingDeck = [...workingDeck];
            var firstIndex = newWorkingDeck.indexOf(card.baseid);
            if (firstIndex == -1) {
              firstIndex = newWorkingDeck.length;
            }
            newWorkingDeck.splice(firstIndex, 0, card.baseid);
            setWorkingDeck(newWorkingDeck);
          }
        };
      }
      break;
    default:
  }
};

var timeout;

export const ContextMenuKeepOpen = () => {
  clearTimeout(timeout);
};

export const ContextMenuClose = (setState) => {
  return () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setState(initialMenuState);
    }, 200);
  };
};

function OnError(event) {
  //event.persist();
  //console.log(event.target.attributes['src']);
  event.target.src = "https://assets.orangeswim.dev/other/blank.png";
}

const visibleProps = {
  name: "Name",
  ctype: "Card Type",
  color: "Color",
  lv: "Level",
  cost: "Play Cost",
  ecost: "Digivolve Cost",
  ecost2: "Digivolve Cost-2",
  ecostcolor: "Digivolve Color",
  ecostcolor2: "Digivolve Color-2",
  dp: "Power",
  dtype: "Type",
  attr: "Attribute",
  stage: "Stage Level",
  rare: "Rarity",
  notes: "Notes",
  artist: "Artist",
};

const visibleLongProps = {
  src: "Source",
  meffect: "Effect",
  seffect: "Inherited Effect",
  seceffect: "Security Effect",
};

export function ContextMenuComponent(props) {
  /*
  const [state, setState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  */
  const { menuState } = cardsStore.useCards();
  const { setMenuState } = cardsStore;
  //const { state, setState } = useContext(ContextMenu);
  //var state = props.state;
  //var setState = props.setState;

  const handleClose = () => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      setMenuState(initialMenuState);
    }, 200);
  };

  const handleCloseInstant = () => {
    setMenuState(initialMenuState);
  };

  const card: DigimonData = menuState.card
    ? menuState.card
    : CardInfo[0].set[0];
  const show = menuState.card ? 1 : 0;
  const classes = useStyles({ show: show });
  window.card = card;

  const visiblePropsKeys = Object.keys(visibleProps);
  const visibleLongPropsKeys = Object.keys(visibleLongProps);
  const vprops = Object.keys(card)
    .filter(
      (val) =>
        visiblePropsKeys.includes(val) &&
        card[val] != null &&
        ((card[val].length != undefined && card[val].length > 0) ||
          typeof card[val] == "number")
    )
    .map((val) => {
      return { key: visibleProps[val], value: card[val] };
    });
  const vlongprops = Object.keys(card)
    .filter((val) => visibleLongPropsKeys.includes(val) && card[val] != null)
    .map((val) => {
      return { key: visibleLongProps[val], value: card[val] };
    });

  const url = card.imageUrl
    ? card.imageUrl
    : `https://assets.orangeswim.dev/images/mons/${[card.id]}.jpg`;

  return (
    <StyledMenu
      keepMounted
      open={menuState.mouseY !== null}
      onClose={handleCloseInstant}
      anchorReference="anchorPosition"
      anchorPosition={
        menuState.mouseY !== null && menuState.mouseX !== null
          ? { top: menuState.mouseY, left: menuState.mouseX }
          : undefined
      }
      style={{ zIndex: 5000, pointerEvents: "none" }}
    >
      <div className={classes.root} style={{ pointerEvents: "auto" }}>
        <div className={classes.close} onMouseDown={handleCloseInstant}>
          <CancelIcon style={{ color: "#555" }} />
        </div>
        <div className={classes.subroot}>
          <div>
            <img
              onError={OnError}
              draggable="false"
              src={url}
              className={classes.image}
            ></img>
          </div>
          <div className={classes.subCol}>
            <div className={classes.name}>{card.name}</div>
            {vprops.map((item, index) => (
              <div key={item.key} className={classes.property}>
                <div className={classes.label}>{item.key}</div>
                <div className={classes.value}>{item.value}</div>
              </div>
            ))}
            <div className={classes.property}>
              <div className={classes.label}>Card Number</div>
              <div className={classes.value}>{card.id}</div>
            </div>
          </div>
        </div>
        <div className={classes.subCol}>
          {vlongprops.map((item, index) => {
            if (item.value.length > 0) {
              return (
                <div key={index} className={classes.property}>
                  <div className={classes.label}>{item.key}</div>
                  <div className={classes.valueLong}>{item.value}</div>
                </div>
              );
            }
            return <Fragment></Fragment>;
          })}
        </div>
      </div>
    </StyledMenu>
  );
}
